import React, { useEffect, useState } from "react";
import "assets/components/faqConsulenza.scss";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import { Grid, Typography } from "@mui/material";

const faqList = [
  {
    question: "Come funziona nel dettaglio la consulenza?",
    answer: (
      <>
        <p>La procedura è semplicissima, i passaggi sono i seguenti:</p>
        <p className="my-2">
          <strong>1. Accedi</strong>
          <br />
          Registrati con il tuo indirizzo email o accedi con il tuo account
          social.
        </p>
        <p className="my-2">
          <strong>2. Indica il quesito e prenota l’appuntamento</strong>
          <br />
          Nella tua dashboard seleziona giorno e ora in cui ricevere la
          consulenza. Avrai un campo a disposizione per scrivere il tuo quesito
          di natura o descrivere il caso che ti è accaduto.
        </p>
        <p className="my-2">
          <strong>3. Parla con l’avvocato</strong>
          <br />
          Il giorno dell’appuntamento un avvocato si collegherà in videocall con
          te per risolvere il tuo quesito e fornirti tutti i consigli utili,
          anche su eventuali ulteriori azioni da intraprendere.
        </p>
        <p className="my-2">
          <strong>4. Eventuali step successivi</strong>
          <br />
          Se insieme all’avvocato deciderai di proseguire con attività
          successive alla consulenza (es. redazione di diffide, querele,
          documenti, incarichi processuali) ti sarà data ogni indicazione in
          merito.
        </p>
      </>
    ),
  },
  {
    question: "Su cosa posso richiedere consulenza?",
    answer: (
      <>
        <p>
          {" "}
          Trattiamo{" "}
          <span style={{ fontWeight: "bold" }}>
            qualunque tema giuridico di natura penale
          </span>
          . Se avessi bisogno di approfondire temi civilistici, sapremo comunque
          indicarti la strada migliore per il tuo caso.
        </p>
      </>
    ),
  },
  {
    question: "Quanto dura la consulenza?",
    answer: (
      <>
        <p>
          La consulenza ha una{" "}
          <span style={{ fontWeight: "bold" }}>
            durata standard di 30 minuti
          </span>
          . Questo tempo è sufficiente per ricevere una risposta soddisfacente
          al tuo quesito. Se vorrai proseguire oltre questo tempo per qualunque
          ragione, potrai accordarti direttamente con l’avvocato che ti
          presenterà un preventivo specifico per proseguire con l’attività.
        </p>
      </>
    ),
  },
  {
    question: "La consulenza si svolge online?",
    answer: (
      <>
        <p>
          Sì, non devi recarti fisicamente in nessun ufficio. Ti inviamo un link
          di accesso a una{" "}
          <span style={{ fontWeight: "bold" }}>videocall dedicata</span>.
        </p>
      </>
    ),
  },
  {
    question: "Posso richiedere una consulenza urgente?",
    answer: (
      <>
        <p>
          Certo! Se non trovi un appuntamento idoneo tramite la nostra
          dashboard,{" "}
          <span style={{ fontWeight: "bold" }}>scrivici in chat</span> e faremo
          il possibile per darti un appuntamento entro le successive 24 ore.
        </p>
      </>
    ),
  },
  {
    question: "Se sono minorenne posso richiedere una consulenza?",
    answer: (
      <>
        <p>
          Sì, purché tu abbia compiuto{" "}
          <span style={{ fontWeight: "bold" }}>almeno 14 anni di età</span>. In
          alcuni casi potrebbe essere comunque necessaria la presenza di un tuo
          parente o tutore.
        </p>
      </>
    ),
  },
  {
    question: "Quali sono i vantaggi della consulenza con DenunciaOnline?",
    answer: (
      <>
        <p>
          Con il nostro servizio puoi richiedere una{" "}
          <span style={{ fontWeight: "bold" }}>
            consulenza ovunque ti trovi
          </span>
          . Eviti perdite di tempo per spostamenti in città e non dovrai
          chiedere permessi o ferie a lavoro. Quando in gioco c’è il diritto
          penale, si può avere il timore di parlare con un avvocato del proprio
          luogo per evitare di essere esposti in città. Noi ti aiutiamo a
          superare anche questo limite, con un avvocato online a tua completa
          disposizione.
        </p>
      </>
    ),
  },
  {
    question: "Quali sono i passaggi successivi alla consulenza?",
    answer: (
      <>
        <p>
          {" "}
          In genere, con i 30 minuti di consulenza vengono risolti i quesiti che
          non richiedono ulteriore attività. Nel caso in cui desiderassi
          richiedere all’avvocato le attività successive suggerite o necessarie
          (es. redazione di diffide, querele, documenti, incarichi processuali),
          ti daremo tutte le indicazioni presentandoti nel dettaglio i costi
          aggiuntivi. Sarai{" "}
          <span style={{ fontWeight: "bold" }}>
            sempre libero di accettare o meno
          </span>{" "}
          il preventivo proposto.
        </p>
      </>
    ),
  },
  {
    question: "Il servizio è sicuro?",
    answer: (
      <>
        <p>
          Hai la nostra garanzia! Tutti{" "}
          <span style={{ fontWeight: "bold" }}>
            i tuoi dati rimarranno sempre protetti
          </span>{" "}
          e non saranno divulgati. Puoi fidarti di noi, prendiamo il nostro
          mestiere molto seriamente.
        </p>
      </>
    ),
  },
  {
    question: "Come posso pagare?",
    answer: (
      <>
        <p>
          Puoi acquistare il servizio con{" "}
          <span style={{ fontWeight: "bold" }}>carta o PayPal</span>. Paghi solo
          per la singola consulenza acquistata e per gli eventuali ulteriori
          servizi/attività di cui deciderai di avvalerti. Non ci sarà nessun
          addebito automatico ricorrente.
        </p>
      </>
    ),
  },
];

const FaqConsulenza = (props) => {
  const [openIndexes, setOpenIndexes] = useState([]);

  const toggleAnswer = (index) => {
    if (openIndexes.includes(index)) {
      setOpenIndexes(openIndexes.filter((i) => i !== index));
    } else {
      setOpenIndexes([...openIndexes, index]);
    }
  };

  return (
    <Grid
      id="Faq"
      container
      className="container container-section-6-consulenza"
      sx={{
        display: "flex",
        justifyContent: { xs: "start !important", md: "center !important" },
      }}
    >
      <Grid item xs={12} md={9} style={{ marginBottom: "20px" }}>
        <h1 className="color1 title-sectionFaq-consulenza">Faq</h1>
        <Typography
          className="color5 subtitle-sectionFaq-consulenza"
          style={{ fontWeight: 600 }}
        >
          Domande frequenti sulla consulenza
        </Typography>
      </Grid>

      {faqList.map((faq, index) => (
        <React.Fragment key={index}>
          {/* DOMANDA */}
          <Grid
            item
            xs={12}
            md={9}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Grid
              item
              xs={12}
              onClick={() => toggleAnswer(index)}
              sx={{
                marginTop: "15px",
                // backgroundColor: "#eaf2f7",
                backgroundColor: "#fff",
                border: "2px solid #95e0e44f",
                borderRadius: "4px",
                padding: { xs: "10px", md: "15px" },
                display: "flex",
                width: "fit-content",
                cursor: "pointer",
              }}
            >
              <Grid item xs={10}>
                <Typography
                  className="color1"
                  sx={{ fontSize: { xs: "14px", sm: "16px" }, fontWeight: 600 }}
                >
                  {faq.question}
                </Typography>
              </Grid>
              <Grid
                item
                xs={2}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <div
                  className={`icon-arrow-faq ${
                    openIndexes.includes(index) ? "rotate" : ""
                  }`}
                  style={{ marginLeft: "10px", alignSelf: "center" }}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* RISPOSTA */}
          {openIndexes.includes(index) && (
            <Grid
              item
              xs={12}
              md={9}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <div
                style={{
                  backgroundColor: "#95e0e44f",
                  borderRadius: "4px",
                  padding: "15px",
                  marginTop: "15px",
                  width: "90%",
                }}
              >
                <Typography
                  className="color1"
                  sx={{ fontSize: { xs: "14px", sm: "16px" }, fontWeight: 400 }}
                >
                  {faq.answer}
                </Typography>
              </div>
            </Grid>
          )}
        </React.Fragment>
      ))}

      <Grid
        item
        xs={12}
        md={9}
        sx={{ marginTop: "30px", display: { xs: "block", md: "flex" } }}
      >
        {" "}
        <Grid item xs={10} md={6} lg={5}>
          <a href="/register" className="btn btn-section-consulenza">
            Richiedi subito
          </a>
        </Grid>
        <Grid item xs={10} md={6} lg={5}>
          {" "}
          <p
            className="color1"
            style={{
              color: "#20305b",
              marginTop: "30px",
            }}
          >
            Hai ancora dubbi?{" "}
            <a
              href="https://chatting.page/wwiccu68pwawmgqq8qyafoe7daqap8ek"
              target="_blanck"
              className="color1"
              style={{
                fontWeight: "bold",
                color: "#20305b",
                marginLeft: "5px",
              }}
            >
              Scrivici in chat
            </a>{" "}
          </p>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FaqConsulenza;
